<div class="login-page">
    <div class="login-wrap">
        <img
            class="login-logo"
            alt="HOMER - Health Operations & Medical Emergency Response"
            src="assets/images/logos/logo.png"
        />

        @switch (loginReason) {
            @case ('inactive') {
                <div class="alert alert-warning text-center mb-3">
                    You must sign back in because you had a period of inactivity during your session.
                </div>
            }
            @case ('expired') {
                <div class="alert alert-warning text-center mb-3">
                    Your session has expired. Sign in again to pick up where you left off.
                </div>
            }
        }

        <div class="login-card rounded bg-light border">
            <div class="p-4">
                @if (isError) {
                    <div class="text-danger text-center mb-3">{{ errorString }}</div>
                }

                <!-- #region Regular / SSO login -->
                @if (!mfaTokenEnabled && !showMfa) {
                    @if (!isUsingSsoLogin) {
                        <form
                            #myForm
                            [formGroup]="loginForm"
                            (ngSubmit)="onSubmit()"
                        >
                            <div class="mb-3">
                                <p-floatlabel variant="on">
                                    <p-iconfield>
                                        <input
                                            pInputText
                                            class="w-100"
                                            formControlName="userName"
                                            autocomplete="username"
                                        />
                                        <p-inputicon styleClass="pi pi-user" />
                                    </p-iconfield>
                                    <label>Username</label>
                                </p-floatlabel>
                            </div>

                            <div class="mb-3">
                                <p-floatlabel variant="on">
                                    <p-password
                                        styleClass="w-100"
                                        inputStyleClass="w-100"
                                        formControlName="password"
                                        [feedback]="false"
                                        [toggleMask]="true"
                                    />
                                    <label>Password</label>
                                </p-floatlabel>
                            </div>

                            <p-button
                                class="w-100"
                                type="submit"
                                label="Login"
                                styleClass="w-100"
                                raised
                                severity="info"
                                [loading]="isLoading()"
                            />

                            <div class="d-flex justify-content-center flex-wrap mt-2">
                                <p-button
                                    label="Register new account"
                                    [link]="true"
                                    severity="info"
                                    size="small"
                                    (onClick)="router.navigate(['/help-ticket'], { queryParams: { id: 'register' } })"
                                />
                                <p-button
                                    label="Forgot password"
                                    [link]="true"
                                    severity="info"
                                    size="small"
                                    (onClick)="router.navigate(['/forgot-password'])"
                                />
                                <p-button
                                    label="Login with SSO"
                                    [link]="true"
                                    severity="info"
                                    size="small"
                                    (onClick)="switchSso()"
                                />
                            </div>
                        </form>
                    } @else {
                        <form (ngSubmit)="ssoLogin()">
                            <div class="mb-3">
                                <p-floatlabel variant="on">
                                    <p-iconfield>
                                        <input
                                            pInputText
                                            class="w-100"
                                            [(ngModel)]="ssoEmail"
                                            name="ssoEmail"
                                            maxlength="51"
                                            autocomplete="on"
                                        />
                                        <p-inputicon styleClass="pi pi-envelope" />
                                    </p-iconfield>
                                    <label>Email</label>
                                </p-floatlabel>
                            </div>

                            <p-button
                                class="w-100"
                                type="submit"
                                label="Login"
                                styleClass="w-100"
                                raised
                                severity="info"
                                [loading]="isLoading()"
                            />
                            <div class="d-flex justify-content-center mt-2">
                                <p-button
                                    label="Regular login"
                                    [link]="true"
                                    severity="info"
                                    size="small"
                                    (onClick)="switchSso()"
                                />
                            </div>
                        </form>
                    }
                }
                <!-- #endregion -->

                <!-- #region MFA type selection -->
                @if (showMfa) {
                    <div class="text-center">
                        <label class="text-danger d-block mb-3">
                            Please select a Multi-Factor Authentication type
                        </label>
                        <div class="d-flex justify-content-center flex-wrap">
                            <p-button
                                class="mr-2"
                                label="Device"
                                icon="pi pi-external-link"
                                severity="secondary"
                                outlined
                                (onClick)="fidoMfa()"
                            />
                            <p-button
                                label="SecuGen"
                                icon="pi pi-verified"
                                severity="secondary"
                                outlined
                                (onClick)="fingerprintMfa()"
                            />
                        </div>
                    </div>
                }
                <!-- #endregion -->

                <!-- #region MFA token entry -->
                @if (mfaTokenEnabled) {
                    <div>
                        <p class="text-center">
                            Multi-Factor Authentication Code Detected.
                            <br />
                            Please enter your MFA code below:
                        </p>
                        <div class="mb-3">
                            <input
                                #mfaToken
                                pcgNumeric
                                pInputText
                                type="text"
                                maxlength="6"
                                class="w-100 text-center"
                                name="mfaToken"
                                autocomplete="one-time-code"
                                placeholder="------"
                            />
                        </div>
                        <p-button
                            class="w-100"
                            label="Submit"
                            styleClass="w-100"
                            raised
                            severity="info"
                            (onClick)="verifyMfaToken(mfaToken.value)"
                        />

                        @if (isMfaError) {
                            <div class="text-danger text-center mt-2">{{ mfaErrorString }}</div>
                        }
                        @if (isResendCode) {
                            <div class="alert alert-success mt-2 mb-0">MFA code resent successfully.</div>
                        }

                        <div class="d-flex justify-content-center mt-2">
                            <p-button
                                label="Resend code"
                                [link]="true"
                                severity="info"
                                size="small"
                                (onClick)="resendCode()"
                            />
                        </div>
                    </div>
                }
                <!-- #endregion -->
            </div>
        </div>
    </div>
</div>
